import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["onClosed", "onCancel", "onConfirm", "onClose", "cancelProps", "confirmProps"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

/* eslint-disable @typescript-eslint/naming-convention */
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { noop } from '../utils';
import BaseDialog from './Dialog';
import { resolveContainer } from '../utils/dom/getContainer';
var Dialog = BaseDialog; // 可返回用于销毁此弹窗的方法

Dialog.show = function (props) {
  var defaultOptions = {
    overlay: true,
    closeable: false,
    closeIcon: 'cross',
    lockScroll: true,
    transition: 'rv-dialog-bounce',
    showConfirmButton: true,
    showCancelButton: false,
    closeOnClickOverlay: false
  };

  var onClosed = props.onClosed,
      _props$onCancel = props.onCancel,
      onCancel = _props$onCancel === void 0 ? noop : _props$onCancel,
      _props$onConfirm = props.onConfirm,
      onConfirm = _props$onConfirm === void 0 ? noop : _props$onConfirm,
      _props$onClose = props.onClose,
      onClose = _props$onClose === void 0 ? noop : _props$onClose,
      cancelProps = props.cancelProps,
      confirmProps = props.confirmProps,
      restProps = _objectWithoutProperties(props, _excluded);

  var userContainer = resolveContainer(props.teleport);
  var container = document.createElement('div');
  userContainer.appendChild(container);
  var destroy = noop;

  var TempDialog = function TempDialog() {
    var _useState = useState(false),
        _useState2 = _slicedToArray(_useState, 2),
        visible = _useState2[0],
        setVisible = _useState2[1];

    var _useState3 = useState(false),
        _useState4 = _slicedToArray(_useState3, 2),
        cancelLoading = _useState4[0],
        setCancelLoading = _useState4[1];

    var _useState5 = useState(false),
        _useState6 = _slicedToArray(_useState5, 2),
        okLoading = _useState6[0],
        setOkLoading = _useState6[1];

    useEffect(function () {
      setVisible(true);
    }, []);

    destroy = function destroy() {
      setVisible(false);
      if (onClose) onClose();
    };

    var _afterClose = function _afterClose() {
      if (onClosed) {
        onClosed();
      }

      var unmountResult = ReactDOM.unmountComponentAtNode(container);

      if (unmountResult && container.parentNode) {
        container.parentNode.removeChild(container);
      }
    };

    var _onConfirm = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
        var i;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                i = setTimeout(function () {
                  return setOkLoading(true);
                });
                _context.next = 3;
                return onConfirm(e);

              case 3:
                _context.t0 = _context.sent;

                if (!(_context.t0 !== false)) {
                  _context.next = 9;
                  break;
                }

                clearTimeout(i);
                destroy();
                _context.next = 11;
                break;

              case 9:
                clearTimeout(i);
                setOkLoading(false);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function _onConfirm(_x) {
        return _ref.apply(this, arguments);
      };
    }();

    var _onCancel = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e, clickOverlay) {
        var i;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!clickOverlay) {
                  _context2.next = 3;
                  break;
                }

                destroy();
                return _context2.abrupt("return");

              case 3:
                i = setTimeout(function () {
                  return setCancelLoading(true);
                });
                _context2.next = 6;
                return onCancel(e);

              case 6:
                _context2.t0 = _context2.sent;

                if (!(_context2.t0 !== false)) {
                  _context2.next = 12;
                  break;
                }

                clearTimeout(i);
                destroy();
                _context2.next = 14;
                break;

              case 12:
                clearTimeout(i);
                setCancelLoading(false);

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function _onCancel(_x2, _x3) {
        return _ref2.apply(this, arguments);
      };
    }();

    return /*#__PURE__*/React.createElement(BaseDialog, _extends({}, defaultOptions, restProps, {
      visible: visible,
      teleport: function teleport() {
        return container;
      },
      cancelProps: _objectSpread({
        loading: cancelLoading
      }, cancelProps),
      confirmProps: _objectSpread({
        loading: okLoading
      }, confirmProps),
      onClose: destroy,
      onCancel: _onCancel,
      onConfirm: _onConfirm,
      onClosed: _afterClose
    }));
  };

  ReactDOM.render( /*#__PURE__*/React.createElement(TempDialog, null), container);
  return destroy;
}; // 可使用 async/await 的方式


Dialog.alert = function (props) {
  var _props$onConfirm2 = props.onConfirm,
      _onConfirm2 = _props$onConfirm2 === void 0 ? noop : _props$onConfirm2;

  return new Promise(function (resolve) {
    Dialog.show(_objectSpread(_objectSpread({}, props), {}, {
      onConfirm: function onConfirm(e) {
        _onConfirm2(e);

        resolve(e);
      }
    }));
  });
};

Dialog.confirm = function (props) {
  var _props$onCancel2 = props.onCancel,
      _onCancel2 = _props$onCancel2 === void 0 ? noop : _props$onCancel2,
      _props$onConfirm3 = props.onConfirm,
      _onConfirm3 = _props$onConfirm3 === void 0 ? noop : _props$onConfirm3;

  return new Promise(function (resolve, reject) {
    Dialog.show(_objectSpread(_objectSpread({
      // 强制显示 OK Btn
      confirmButtonText: '确认',
      showCancelButton: true
    }, props), {}, {
      onCancel: function onCancel(e) {
        _onCancel2(e);

        reject();
      },
      onConfirm: function onConfirm(e) {
        _onConfirm3(e);

        resolve(true);
      }
    }));
  });
};

export default Dialog;